module.exports = __webpack_public_path__ + "img/payment_term_filled.a469dab.svg";